import { useState } from 'react';
import MonthlyHousesAspects from '@/pages/MonthlyHousesAspects';
import { getMonthlyDateRange } from '@/utils/getMonthlyDateRange';
import { formatMonthlyLabel } from '@/utils/formatMonthYear';
import { SegmentedControl } from '@/components/ui/SegmentedControl';

const MonthlyPredictionsTabs = () => {
  const [activeMonth, setActiveMonth] = useState<'current' | 'next'>('current');
  const baseFromDate = getMonthlyDateRange('current').fromDate;

  const currentTabLabel = formatMonthlyLabel(baseFromDate, { hideYear: true });

  const nextTabLabel = formatMonthlyLabel(
    new Date(
      new Date(baseFromDate).getFullYear(),
      new Date(baseFromDate).getMonth() + 1,
      1
    ).toISOString(),
    { hideYear: true }
  );

  const handleMonthChange = (month: 'current' | 'next') => {
    if (month === activeMonth) return;
    setActiveMonth(month);
  };

  return (
    <div className="space-y-6 relative flex flex-col items-center">
      {/* Tabs */}
      <SegmentedControl
        options={[
          { label: currentTabLabel, value: 'current' },
          { label: nextTabLabel, value: 'next' },
        ]}
        value={activeMonth}
        onChange={(val) => handleMonthChange(val as 'current' | 'next')}
      />

      <div className="w-full">
        <MonthlyHousesAspects activeMonth={activeMonth} setActiveMonth={setActiveMonth} />
      </div>
    </div>
  );
};

export default MonthlyPredictionsTabs;
